export default "__VITE_ASSET__BXAc5091__"